import React from 'react';
import { Rocket } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../config/routes';
import { Button } from '../../../components/ui/button';
import { useAuthStore } from '../../../stores/authStore';
import { getTrialRemainingDays } from '../../../lib/utils';

interface UpgradeBannerProps {
  suggestion: string;
  onDismiss: () => void;
}

export const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ suggestion, onDismiss }) => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const trialRemainingDays = user?.trial_ends_at
    ? getTrialRemainingDays(user.trial_ends_at)
    : null;
  const isTrialEndingSoon = trialRemainingDays !== null && trialRemainingDays <= 7;

  return (
    <div
      data-testid="upgrade-banner"
      className="mb-6 p-4 bg-primary/10 border border-primary rounded-lg"
    >
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="p-2 rounded-lg bg-primary/10 flex-shrink-0">
            <Rocket className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm font-semibold">
              {isTrialEndingSoon
                ? '現在の設定・学習データはアップグレードすれば引き継がれます。トライアル終了後はドメインが停止します'
                : 'Proプランなら月1,000メッセージ＋10BOT。詳しく見る →'}
            </p>
            <p className="text-xs text-text-secondary mt-1">
              {suggestion}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate(ROUTES.SUBSCRIPTION)}
            data-testid="upgrade-banner-cta"
          >
            プランを見る
          </Button>
          <Button
            variant="ghost"
            onClick={onDismiss}
            data-testid="upgrade-banner-dismiss"
          >
            今はしない
          </Button>
        </div>
      </div>
    </div>
  );
};
